export default __webpack_public_path__ + "static/media/supervision.11a48eda.png";